// extracted by mini-css-extract-plugin
export default {"root":"Logo_root-Trd"};